/**
 * TOP PICKS MODULE
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var checkIf = VP.helpers.checkIf;
	var SELECTOR = {
		module: '.js-top-picks',
		cover: '.js-top-picks__cover',
		coverImage: '.js-top-picks__cover__image',
		list: '.js-top-picks__list',
		item: '.js-top-picks__item',
		itemImage: '.js-top-picks__article__image',
		loadAllButton: '.js-top-picks__load-all-btn',
	};
	var CLASSNAME = {
		activeCoverImage: 'vp-top-picks__cover__image--active',
		activeItem: 'vp-top-picks__article--active',
		fadedItem: 'vp-top-picks__item--faded',
		allItemsVisible: 'vp-top-picks--all-items-visible',
	};
	var CAROUSEL_OPTIONS = {
		infinite: true,
		slidesToShow: 4,
	  	slidesToScroll: 1,
	  	responsive: [
	  		{
		      breakpoint: 998,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 1
		      }
		    }
	  	]
	  };

	/**
	 * TOPPICKS CLASS
	 */
	var TopPicks = function ($element) {
		// Just ensure we have a jQuery object here
		this.$element = $($element);
		this.element = this.$element[0];

		this.$cover = this.$element.find(SELECTOR.cover);
		this.$coverImage = this.$element.find(SELECTOR.coverImage+":not(.ie11-fallback)");
		this.$list = this.$element.find(SELECTOR.list);
		this.$items = this.$element.find(SELECTOR.item);
		this.$loadAllButton = this.$element.find(SELECTOR.loadAllButton);

		var elementData = this.$element.data();

		this.enabledBreakpoint = elementData.enabledBreakpoint ? elementData.enabledBreakpoint.split(',') : '';

		this.bindCarouselItems();
		this.bindCarousel();
		this.bindLoadAllButton();

		// Activate first item
		this.activateItem( 0 );

	};

	TopPicks.prototype = $.extend({}, TopPicks.prototype, {
		// Checks whether to enable/disable carousel on current breakpoint
		onBreakpointChange: function ( breakpointName ) {

			if ( !this.enabledBreakpoint ) { return; }

			// If current breakpoint should enable carousel
			if ( this.enabledBreakpoint.indexOf(breakpointName) > -1 ) {
				this.enableCarousel();
			}
			// If current breakpoint should destroy carousel
			else {
				this.destroyCarousel();
			}
		},

		bindLoadAllButton: function () {

			var _this = this;

			// If there are only <= 5 items, just hide the button
			if ( _this.$items.length <= 5 ) {
				return _this.$element.addClass( CLASSNAME.allItemsVisible );
			}

			// We only listen once, since remaining items will load at once
			this.$loadAllButton.one( 'touchstart click', function (e) {
				e.preventDefault();
				_this.$element.addClass( CLASSNAME.allItemsVisible );
			});

		},

		bindCarouselItems: function () {
			var _this = this;

			this.$items.each(function ( index, _item ) {

				$(_item)
				.attr('data-item-index', index)
				.on('mouseover', function (e) {

					if ( !_this.enabled ) { return true; }
					if ( _this.activeItemIndex === index ) { return true; }

					e.preventDefault();
					e.stopPropagation();

					_this.activateItem( index );
				});
			});
		},

		bindCarousel: function () {
			var _this = this;
			this.$list
			.bind('init reInit', function ( event, slick ) {
				_this.carouselData = slick;
				_this.enabled = true;
				_this.fadeEdges();
			})
			.bind('beforeChange', function ( event, slick, currentSlide, nextSlide ) {
				_this.fadeEdges( nextSlide );
			});
		},

		// Activates an item acc. to index
		activateItem: function ( index ) {
			if ( this.activeItemIndex === index ) { return; }

			var $currentItem = this.$list.find('[data-item-index='+ this.activeItemIndex +']');
			var $targetItem = this.$list.find('[data-item-index='+ index +']');

			var $currentCoverImage = this.$coverImage.eq( this.activeItemIndex );
			var $targetCoverImage = this.$coverImage.eq( index );


			$currentCoverImage.removeClass( CLASSNAME.activeCoverImage );
			$targetCoverImage.addClass( CLASSNAME.activeCoverImage );
			$currentItem.removeClass( CLASSNAME.activeItem );
			$targetItem.addClass( CLASSNAME.activeItem );

			this.activeItemIndex = index;
		},

		fadeEdges: function ( referenceIndex ) {
			referenceIndex = ( checkIf(referenceIndex).isNot(undefined) && checkIf(referenceIndex).isNot(null) ) ? referenceIndex : 0;
			var leftMostIndex = referenceIndex - 1;
			var rightMostIndex = referenceIndex + CAROUSEL_OPTIONS.slidesToShow;
			var $slides = this.carouselData.$slideTrack.children();
			var fadedItemsSelector = [ '[data-slick-index='+ leftMostIndex +']', '[data-slick-index='+ rightMostIndex +']' ].join(',');
			var $slidesToFade = $slides.filter( fadedItemsSelector );
			$slides.removeClass( CLASSNAME.fadedItem );
			$slides.filter( fadedItemsSelector ).addClass( CLASSNAME.fadedItem );
		},

		enableCarousel: function () {
			if ( this.enabled ) { return; }
			this.$list.slick( CAROUSEL_OPTIONS );
		},

		destroyCarousel: function () {
			if ( !this.enabled ) { return; }
			this.$list.slick('unslick');
			this.enabled = false;
			this.carouselData = null;
		}

	});

	/**
	 * TOPPICKS MODULE ATTACHED TO APP
	 */
	VP.topPicks = {
		$elements: $(SELECTOR.module),
		instances: [],

		init: function () {
			var _this = this;

			_this.$elements.each(function () {
				_this.instances.push(new TopPicks(this));
			});

			VP.breakpoint.onChange( _this.onBreakpointChange.bind(_this), true);

		},


		onBreakpointChange: function ( breakpointName ) {
			this.instances.forEach(function ( _instance ) {
				_instance.onBreakpointChange( breakpointName );
			});
		}

	};
})(jQuery);
